import React, { useState } from 'react';
import { Button, TextField, Typography, Grid, useMediaQuery, useTheme, InputAdornment } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox'; 
import LockOpenIcon from '@mui/icons-material/LockOpen'; 
import { Link } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom';

function Register() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false); 
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

 
const handleRegister = async (event) => {
  event.preventDefault();

  if (email === '' || username === '' || password === '' || confirmPassword === '') {
    setErrorMessage('Please fill in all fields.');
    return;
  }

  if (password !== confirmPassword) {
    setErrorMessage('Passwords do not match.');
    return;
  }

  setErrorMessage('');
  setLoading(true);

  try {
    const response = await fetch('https://api.hub4food.colab4food.com/api/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        name: username,
        password,
        entity_id: null, 
        user_permission_id: null, 
        country: '',
        contact: '',
        description: '',
      }),
    });

    const data = await response.json();

   if (response.ok) {
  alert('Registration successful! Please check your email to activate your account.');
  navigate('/login'); 
} else {
  setErrorMessage(data.message || data.error || 'Failed to register user.');
}
  } catch (error) {
    console.error('Error registering user:', error);
    setErrorMessage('Server error. Please try again later.');
  }

  setLoading(false);
};
  return (
    <Grid container className="container" style={{ height: '100vh' }}>
      {/* Seção da esquerda */}
      <Grid
        item
        xs={12}
        sm={6}
        className="left-section"
        style={{
          backgroundColor: '#f5f8fc',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <Typography 
          variant="h3" 
          gutterBottom
          style={{
            color: '#000000',
            textShadow: `
              0 0 10px #fff,
              0 0 10px #fff,
              0 0 10px #fff,
              0 0 10px #fff
            `,
            fontWeight: 'bold'
          }}
        >
          Your gateway to food innovation!
        </Typography>
        <Typography 
          variant="h5" 
          gutterBottom
          style={{
            color: '#000000',
            textShadow: `
              0 0 8px #fff,
              0 0 8px #fff,
              0 0 8px #fff
            `,
            fontWeight: '600'
          }}
        >
          Join Hub4Food<sup>®</sup>
        </Typography>
        <div className="left-section-footer">
          <Typography variant="body2">
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#007bff', textDecoration: 'none' }}>
              Login
            </Link>
          </Typography>
        </div>
      </Grid>

      {/* Seção da direita */}
      <Grid
        item
        xs={12}
        sm={6}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
        }}
      >
        <img
          src="/logotipo.png"
          alt="Hub4Food Logo"
          className="logo"
          style={{ width: isMobile ? '60px' : '80px', marginBottom: '20px' }}
        />
        <Typography variant="h5" gutterBottom>
          Let us get to know you!
        </Typography>
        <form id="register-form" onSubmit={handleRegister} style={{ width: '100%', maxWidth: '300px' }}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
            placeholder="Enter your email"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountBoxIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            margin="normal"
            placeholder="Choose a username"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountBoxIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            margin="normal"
            placeholder="Enter your password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Confirm Password"
            type="password"
            variant="outlined"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            margin="normal"
            placeholder="Confirm your password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="login-button"
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '10px',
              fontSize: '16px',
            }}
            disabled={loading}
          >
            {loading ? 'Registering...' : 'Register'}
          </Button>
        </form>

        {errorMessage && (
          <Typography color="error" className="error-message" style={{ marginTop: '10px', textAlign: 'center' }}>
            {errorMessage}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

export default Register;
